import React from 'react';
import {
  OptionInput,
  InputName,
  InputValue,
  InputChecked,
  InputDisabled,
} from '../Form/OptionInput';

interface RadioProps {
  name: InputName;
  value: InputValue;
  checked: InputChecked;
  disabled?: InputDisabled;
  children?: React.ReactNode;
  onClick?: (value: string | number) => void;
}

export function RadioInput({
  children,
  name,
  value,
  checked,
  disabled,
  onClick,
}: RadioProps) {
  return (
    <OptionInput
      type="radio"
      name={name}
      value={value}
      checked={checked}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </OptionInput>
  );
}
